// extracted by mini-css-extract-plugin
export default {"rivers":"WorkflowSection-module__rivers--ylAjZ","bento":"WorkflowSection-module__bento--YlffP"};